export default __webpack_public_path__ + "static/media/Prospero logo.18490732.png";